import { render } from "./IpInfo.vue?vue&type=template&id=426bbe00"
import script from "./IpInfo.vue?vue&type=script&lang=ts"
export * from "./IpInfo.vue?vue&type=script&lang=ts"
script.render = render

export default script